import { render, staticRenderFns } from "./people-create.vue?vue&type=template&id=0e113017&"
import script from "./people-create.vue?vue&type=script&lang=ts&"
export * from "./people-create.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports